import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "aura-chat h-[calc(100dvh-64px)] min-h-0 w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Main chat interface - integrated with portal sidebar/header "),
    (_openBlock(), _createBlock($setup["AuraComposer"], {
      key: $setup.levelId ?? 'no-level',
      "is-loading": $setup.isLoading
    }, null, 8 /* PROPS */, ["is-loading"]))
  ]))
}